import React, {useState, useEffect} from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import InputMasked from "react-input-mask";
import Tour from "reactour";
import { ToastContainer } from "react-toastify";

//Services
import api from "../../../service/api";

//Components
import Main from "../../../components/Main/index";
import Header from "../../../components/Header";
import NavTabs from "../../../components/NavTabs";
import Input from "../../../components/Input";
import ModalShare from "../../../components/ModalShare";
import Select from "../../../components/Select";
import ErrorMessage from "../../../components/ErrorMessage";
import { TitleTour, ContentText } from "../../../components/ReactourComponents/styles";

//Styles
import { ContainerForm, Legend, ContainerInput, ErrorMessageInput } from "./styles";

//Routes
import routesCard from "../../../routes/card.routes";

//Help Function
import { openModal, closeModal } from "../../../helpers/modalFunctions";

//Assets
import colors from "../../../assets/css/colors";

// Utils
import { toastCreate, toastUpdate } from "../../../utils/notifications/toast";
import { notifysFieldsForm } from "../../../utils/notifications/notifyForm";
import convertAmountInCents from "../../../utils/amountInCents";
import Button from "../../../components/Button";
import Animation from "../../../components/Loading/animation";
import ModalActions from "../../../components/ModalActions";
import ModalWarning from "../../../components/ModalWarning";


const CardPaymentLink = () => {
    const [buyer, setBuyer] = useState({
        email: "",
        phoneNumber: ""
    });

    const [errorOnSubmit, setErrorOnSubmit] = useState(false);
    const [errorOnReturnApi, setErrorOnReturnApi] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [linkId, setLinkId] = useState({
        id: "",
        url: "",
        amount: 0,
        description: "",
        establishment: ""
    });
    const [message, setMessage] = useState("");

    const [phoneNumberPrefix, setPhoneNumberPrefix] = useState("55");

    const [tutorialTourIsOpen, setTutorialTourIsOpen] = useState(false);

    const login = useSelector((state: {login: any}) => state.login);
    const history = useHistory();

    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }

    const query = useQuery();
    
    useEffect(() => {
        if(login.user.groups.cm3a3 === false){
            history.push("/admin/dashboard");
        }

        if(query.get("tutorial") !== null){
            setTutorialTourIsOpen(true)
        }
    }, []);
    
    const formValidationWithYup = Yup.object().shape({
        phoneSms: Yup.string().min(15, "*Quantidade de dígitos inválidos").nullable(true),
        email: Yup.string().email().nullable(true),
        amount: Yup.string().required("*Obrigatório"),
        installments: Yup.number().required("*Obrigatório").min(1, "*Número minímo de parcelas é 1").max(12, "*Número máximo de parcelas é 12"),
        title: Yup.string().required("*Obrigatório"),
    });

    const searchForErrors = (errors: Object) => {
        if(errors !== {}){
          setErrorOnSubmit(true)
        } else {
          setErrorOnSubmit(false)
        }
    }

    const sendEmail = async () => {
        try {
            const {data} = await api.post("linkpay/send/email", {
                email: buyer.email,
                link: linkId.url,
                id: linkId.id,
                establishment: login.user.branchs.businessName
            });

            setMessage("Email enviado com sucesso");
        } catch (error) {
            setMessage("Falha ao enviar email")
        }
    }

    const sendWhatsapp = async () => {
        try{
            const {data} = await api.post("/linkpay/send/whats", {
                link: `${linkId.url}`,
                phoneSms: buyer.phoneNumber,
                amount: linkId.amount,
                establishment: linkId.establishment,
                description: linkId.description
            });

            setMessage("Mensagem enviada com sucesso");
        } catch (err){
            setMessage("Falha ao enviar mensagem");
        }
    }

    const handlePhoneNumberPrefixChange = (e: string) => {
        setPhoneNumberPrefix(e);
    }

    const stepsTutorial = [
        {
            selector: "#form-card",
            content: () => (
                <div>
                    <TitleTour>Link de pagamento</TitleTour>
                    <ContentText>Para criar um link de pagamento preencha os campos.</ContentText>
                </div>
            )
        },
        {
            selector: "#contacts",
            content: () => (
                <div>
                    <TitleTour>Link de pagamento</TitleTour>
                    <ContentText>Os campos de contato do cliente são de preenchimento opcional, contudo, só será possível compartilhar o link via WhatsApp e Email caso eles sejam preenchidos.</ContentText>
                </div>
            )
        },
        {
            selector: "#button-submit",
            content: () => (
                <div>
                    <TitleTour>Link de pagamento</TitleTour>
                    <ContentText>Clique no botão e aguarde a abertura da tela de compartilhamento, você terá a opção de copiar o link ou compatilhá-lo via WhatsApp e/ou Email, para compartilhar, basta clicar no botão da opção escolhida e aguardar a confirmação de envio.</ContentText>
                </div>
            )
        },
    ]

    return(
        <Main>
            <ToastContainer />
            <ModalWarning 
                title="Logo não identificada"             
                description="Para criar link de pagamentos, é necessário fazer o upload da logo da sua empresa. Deseja ir para configurações?" 
                pathBack="/admin/card/token-card"
                pathGo="/admin/configuration/my-cadastre"
            />
            { isLoading && (<Animation/>) }
            <Tour
                steps={stepsTutorial}
                isOpen={tutorialTourIsOpen}
                onRequestClose={() => setTutorialTourIsOpen(false)}
                accentColor={colors.primary}
                showNumber={false}
                showNavigation
                showNavigationNumber={false}
                showButtons
            />
            <Header title="Cartão" subTitle="Associe cartões aos seus clientes para pagamentos via cartão de crédito" subTitleWidth={240}/>
            <NavTabs tabs={routesCard}/>
            <ModalShare 
                text="Link gerado" 
                linkId={linkId.url}
                type={0}
                sendEmail={sendEmail}
                sendWhatsapp = {sendWhatsapp}
                message={message}
                qrCode={login.user.groups.cm8}
                isPowerUser={login.user.powerUser}
            />

            <ContainerForm>
                <fieldset>
                    <Formik
                        initialValues={{
                            amount: "",
                            installments: "",
                            title: "",
                            phoneSms: "",
                            email: "",
                        }}
                        validationSchema={formValidationWithYup}
                        onSubmit={async (values) => {
                            setIsLoading(true)
                            let amountInCents = convertAmountInCents(values.amount)
                            const phoneNumber = values.phoneSms.replace("(", "").replace(")", "").replace("-", "").split(" ").join("");
                            
                            setBuyer({
                                email: values.email,
                                phoneNumber: `${phoneNumberPrefix}${phoneNumber}`
                            })

                            try {
                                const { data } = await api.post("linkpay/create", {
                                    "branchsId": login.user.branchsId,
                                    "sellerOwnerPayId": login.user.branchs.sellerOwnerPayId,
                                    "apiOwnerId": login.user.powerUser === true ? "ZOOP" : login.user.branchs.apiOwner.description,
                                    "amount": amountInCents,
                                    "numberInstalments": values.installments,
                                    "description": values.title,
                                    "phoneSms": phoneNumber,
                                    "tpTransaction": "0", // cartão
                                    "standardLogo": login.user.branchs.standardLogo,
                                    "email": values.email
                                });

                                const urlLinkPay = login.user.groups.cm8 === true
                                    ? `https://100pay-payment-link.netlify.app/payment/igreja/${data.id}`
                                    : `https://100pay-payment-link.netlify.app/${data.id}/${login.token}`
                                
                                setErrorOnReturnApi(false);
                                setLinkId({
                                    id: data.id,
                                    url: urlLinkPay,
                                    amount: amountInCents,
                                    description: values.title,
                                    establishment: login.user.branchs.businessDescription
                                });
                                setMessage("");
                                toastUpdate("btnSubmit","success",2000,"Sucesso" )
                                openModal("exampleModal");
                            } catch (error) {
                                setErrorOnReturnApi(true);
                                toastUpdate("btnSubmit","error",4000, "Ocorreu um problema, entre em contato com o suporte." )
                            } finally {
                                setIsLoading(false)
                            }
                        }}
                    >
                        {({errors, values, handleSubmit, handleChange, touched, dirty, isValid}) => {
                            return(
                                <Form id="form-card">
                                    <Legend>Gerar um link para pagamento</Legend>
                                    <div id="contacts">
                                        <div className="d-flex col-12 p-0">
                                            <div className="col-3 p-0 pr-2">
                                                <Select value={phoneNumberPrefix} onChange={(e) => handlePhoneNumberPrefixChange(e.target.value)}>
                                                    <option disabled hidden value={phoneNumberPrefix}>+{phoneNumberPrefix}</option>
                                                    <option value="55">Brasil (55)</option>
                                                    <option value="598">Uruguai (598)</option>
                                                    <option value="1">Estados Unidos (1)</option>
                                                    <option value="52">México (52)</option>
                                                </Select>
                                            </div>
                                            <div className="col-9 p-0">
                                                <ContainerInput>
                                                <Field
                                                    name="phoneSms"
                                                    id="phoneSms"
                                                    className="input-masked inputCustom" 
                                                    style={{borderColor: `${touched.phoneSms && errors.phoneSms ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                                    placeholder="Telefone"
                                                    mask={phoneNumberPrefix === "55" ? "(99) 99999-9999" : ""} //(99) 99999-9999
                                                    value={values.phoneSms}
                                                    maskChar={null}
                                                    onChange={handleChange}
                                                    type="tel"
                                                    as={InputMasked}    
                                                />
                                                {errors.phoneSms && touched.phoneSms ? <ErrorMessageInput>{ errors.phoneSms }</ErrorMessageInput> : null}
                                                </ContainerInput>
                                            </div>
                                        </div>
                                        <Field
                                            id="email"
                                            name="email"
                                            className="inputCustom" 
                                            style={{borderColor: `${errorOnSubmit && errors.email ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                            placeholder="Email" 
                                            type="email"
                                            as={Input}
                                        />
                                    </div>
                                    <ContainerInput>
                                        <Field 
                                            id="amount" 
                                            name="amount"
                                            className="inputCustom" 
                                            style={{borderColor: `${errors.amount && touched.amount ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                            placeholder="Valor" 
                                            type="text"
                                            as={Input}
                                        />
                                        {errors.amount && touched.amount ? <ErrorMessageInput>{ errors.amount }</ErrorMessageInput> : null}
                                    </ContainerInput>
                                    <ContainerInput>
                                        <Field 
                                            id="installments" 
                                            name="installments" 
                                            type="number" 
                                            min={1} 
                                            className="inputCustom" 
                                            style={{borderColor: `${errors.installments && touched.installments ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                            placeholder="Parcelas" 
                                            as={Input}
                                        />
                                        {errors.installments && touched.installments ? <ErrorMessageInput>{ errors.installments }</ErrorMessageInput> : null}
                                    </ContainerInput>
                                    <ContainerInput>
                                        <Field 
                                            id="title" 
                                            name="title" 
                                            className="inputCustom" 
                                            style={{borderColor: `${touched.title && errors.title ? "red" : "rgba(194, 194, 194, 0.2)"}`}}
                                            placeholder="Titulo da Cobrança" 
                                            as={Input}
                                        />
                                        {errors.title && touched.title ? <ErrorMessageInput>{ errors.title }</ErrorMessageInput> : null}
                                    </ContainerInput>
                                    {
                                        notifysFieldsForm(errors, errorOnSubmit)
                                    }
                                    {
                                        errorOnReturnApi ?
                                            <ErrorMessage>
                                                Falha ao criar link
                                            </ErrorMessage> : null
                                    }
                                    <Button
                                        id="button-submit"
                                        type="submit"
                                        disabled={!(dirty && isValid)}
                                        onClick={() => {
                                            searchForErrors(errors);
                                            toastCreate("btnSubmit", "info", 2000, "Processando")
                                        }}
                                    >
                                        Gerar link
                                    </Button>
                                </Form>
                            )
                        }}
                    </Formik>
                </fieldset>

            </ContainerForm>
        </Main>
    )
}

export default CardPaymentLink;
